
(() => {
  'use strict';

  if (window.MoshuluPlpBackToTop?.version === 3) {
    window.MoshuluPlpBackToTop.refresh();
    return;
  }

  let framePending = false;

  function getScrollRoots() {
    const roots = new Set();

    if (document.scrollingElement) {
      roots.add(document.scrollingElement);
    }

    let element = document.querySelector(
      'product-list[data-collection-product-list]'
    ) || document.querySelector('main');

    while (element) {
      const style = window.getComputedStyle(element);

      if (
        element.scrollHeight > element.clientHeight &&
        /auto|scroll|overlay/.test(style.overflowY)
      ) {
        roots.add(element);
      }

      element = element.parentElement;
    }

    return Array.from(roots);
  }

  function refresh() {
    const isCollection =
      document.body.classList.contains('template-collection') ||
      !!document.querySelector(
        'product-list[data-collection-product-list]'
      );

    const buttons = Array.from(
      document.querySelectorAll('#collection-back-to-top')
    );

    if (!isCollection) {
      buttons.forEach(button => {
        button.classList.remove('is-visible');
        button.hidden = true;
      });
      return;
    }

    let button = buttons[0];

    if (!button) {
      button = document.createElement('button');
      button.id = 'collection-back-to-top';
      button.className = 'collection-back-to-top';
      document.body.appendChild(button);
    }

    button.type = 'button';
    button.setAttribute('aria-label', 'Back to top');
    button.setAttribute('data-plp-back-to-top', '');

    button.innerHTML = '<span aria-hidden="true">↑</span>';

    if (button.parentElement !== document.body) {
      document.body.appendChild(button);
    }

    buttons.forEach(item => {
      if (item !== button) item.remove();
    });

    const visible = getScrollRoots().some(
      root => root.scrollTop > 300
    );

    button.hidden = false;
    button.classList.toggle('is-visible', visible);

    button.style.setProperty(
      'opacity',
      visible ? '1' : '0',
      'important'
    );

    button.style.setProperty(
      'visibility',
      visible ? 'visible' : 'hidden',
      'important'
    );

    button.style.pointerEvents = visible ? 'auto' : 'none';
  }

  function scheduleRefresh() {
    if (framePending) return;

    framePending = true;

    requestAnimationFrame(() => {
      framePending = false;
      refresh();
    });
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest(
      '#collection-back-to-top'
    );

    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    const behavior = reduceMotion ? 'instant' : 'smooth';

    getScrollRoots().forEach(root => {
      if (root !== document.scrollingElement) {
        root.scrollTo({ top: 0, behavior });
      }
    });

    window.scrollTo({ top: 0, behavior });
  }, true);

  document.addEventListener('scroll', scheduleRefresh, {
    capture: true,
    passive: true
  });

  window.addEventListener('scroll', scheduleRefresh, {
    passive: true
  });

  window.addEventListener('resize', scheduleRefresh);

  window.addEventListener('pageshow', scheduleRefresh);

  document.addEventListener(
    'shopify:section:load',
    scheduleRefresh
  );

  document.addEventListener(
    'collection:products-loaded',
    scheduleRefresh
  );

  window.MoshuluPlpBackToTop = {
    version: 3,
    refresh
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      refresh,
      { once: true }
    );
  } else {
    refresh();
  }
})();
